var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"its-cases"},[_c('banner',{attrs:{"banners":_vm.banners}}),_c('ts-page-layout',{attrs:{"center":""}},[_c('div',{staticClass:"its-main"},[_vm._l((_vm.cases),function(c,index){return _c('case-item',{key:'case-' + index,class:index%3===0?'its-no-margin':'',attrs:{"item":c}})}),_c('case-item',{attrs:{"type":"more"}})],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }